import { render, staticRenderFns } from "./left-first.vue?vue&type=template&id=a4ed5a16&scoped=true&"
import script from "./left-first.vue?vue&type=script&lang=js&"
export * from "./left-first.vue?vue&type=script&lang=js&"
import style0 from "./left-first.vue?vue&type=style&index=0&id=a4ed5a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ed5a16",
  null
  
)

export default component.exports